import { Alert } from 'components/common'
import clsx from 'clsx'

interface errorAlertProps {
  alertDescription: string[]
  onCloseAlert: () => void
}

export const ErrorAlert = ({
  alertDescription,
  onCloseAlert,
}: errorAlertProps): JSX.Element => {
  return (
    <>
      <Alert
        className={clsx('mb-5')}
        message={'エラー'}
        description={
          <div>
            {alertDescription?.length > 0 &&
              alertDescription?.map((value, index) => (
                <p style={{ whiteSpace: 'pre-wrap' }} key={`${value}${index}`}>
                  {index > 0 ? `${index + 1}: ${value}` : `${value}`}
                </p>
              ))}
          </div>
        }
        type="error"
        showIcon
        closable
        onClose={onCloseAlert}
      />
    </>
  )
}
